import { motion } from "framer-motion";
import { container, itemUp } from "../Utils/framerMotionVariants";
import { Experience } from "../data/experience";

const ExperienceCard: React.FC<{ experience: Experience }> = ({
  experience,
}) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={container}
      className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-sm"
    >
      <div className="flex items-start justify-between">
        <div>
          <h3 className="font-medium">{experience.role}</h3>
          <p className="text-sm text-gray-300">{experience.company}</p>
        </div>
        <div className="text-sm text-gray-400">{experience.period}</div>
      </div>
      <ul className="mt-3 list-disc list-inside text-sm text-gray-300">
        {experience.bullets.map((b, idx) => (
          <li key={idx}>{b}</li>
        ))}
      </ul>
      <div className="mt-5 flex flex-wrap gap-2">
        {experience.techstack.map((sk) => (
          <motion.span
            variants={itemUp}
            key={sk}
            whileHover={{ scale: 1.05 }}
            className="text-sm px-3 py-2 bg-white/10 border border-white/20 rounded-md shadow-sm"
          >
            {sk}
          </motion.span>
        ))}
      </div>
    </motion.div>
  );
};

export default ExperienceCard;
